<div class="flex-container">
	<div class="choose-steps">
		<button
			nz-button
			nzType="primary"
			(click)="nav.navigate(['my', 'admin', 'setup-wizard', SetupWizardState.EDIT_STEPS_ACCOUNT, clientUuid()])"
		>
			Continue to Setup
		</button>
	</div>
	<div class="or">or</div>
	<div class="view-previous-jobs">
		<button
			nz-button
			nzType="primary"
			(click)="nav.navigate(['my', 'admin', 'setup-wizard', SetupWizardState.VIEW_PREVIOUS_JOBS, clientUuid()])"
		>
			View Previous Jobs
		</button>
	</div>
</div>
